// utility/firebaseStorage.js
import { db } from '@/firebase'

export default {
    presenceRef: null,
    db, // optional: store the db reference if needed
}
